import { MOBILE_WIDTH, TABLET_WIDTH } from "helpers/ScreenSizes";

const PORTAL_DATE_PICKER_FULL_WIDTH_COMPACT = 1240;
const PORTAL_DATE_PICKER_FULL_WIDTH_WIDE = 1400;
const PORTAL_DATE_BAR_NAV_MIN_WIDTH_FULL = 1200;
const PORTAL_DATE_BAR_NAV_MIN_WIDTH_COMPACT = 1040;

export function getPortalDatePickerProps(
  windowWidth: number,
  dateBarMinWidth: number = TABLET_WIDTH,
  fullLayout = false,
) {
  const mobileCompact = windowWidth <= MOBILE_WIDTH;
  const showDateBar = windowWidth > dateBarMinWidth;
  const fullPickerMinWidth = fullLayout ? PORTAL_DATE_PICKER_FULL_WIDTH_WIDE : PORTAL_DATE_PICKER_FULL_WIDTH_COMPACT;
  const iconOnlyTrigger = showDateBar && windowWidth < fullPickerMinWidth;

  return {
    mobileCompact,
    iconOnlyTrigger,
    position: mobileCompact ? ("center" as const) : ("left" as const),
    centeredInputText: mobileCompact,
  };
}

export function getPortalDateBarShowNavigation(windowWidth: number, fullLayout: boolean) {
  const navMinWidth = fullLayout ? PORTAL_DATE_BAR_NAV_MIN_WIDTH_FULL : PORTAL_DATE_BAR_NAV_MIN_WIDTH_COMPACT;
  return windowWidth >= navMinWidth;
}
